import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule} from '@angular/material';

import {StoreModule} from '@ngrx/store';
import {reducers} from './reducers';
import {EffectsModule} from '@ngrx/effects';

import {FloorPlanRoutingModule} from './floor-plan-routing.module';
import {FloorPlanMapComponent} from './components/floor-plan-map/floor-plan-map.component';
import {FloorPlanEmptyComponent} from './components/floor-plan-empty/floor-plan-empty.component';
import {ButtonModule} from '../vision/button';

import {FloorPlanEditorModule} from '../floor-plan-editor/floor-plan-editor.module';
import {FloorPlanViewEffects} from './effects/floor-plan-view.effects';
import {FloorPlanComponent} from './containers/floor-plan/floor-plan.component';
import {FloorPlanHeaderComponent} from './components/floor-plan-header/floor-plan-header.component';
import {IconModule} from '../vision/icon';
import {DeviceMarkerComponent} from './components/device-marker/device-marker.component';
import {FloorPlanSharedModule} from '../floor-plan-shared/floor-plan-shared.module';
import {AirComponentPickerComponent} from './components/air-component-picker/air-component-picker.component';
import {SharedModule} from '../shared';
import {FloorPlanSidebarComponent} from './components/floor-plan-sidebar/floor-plan-sidebar.component';
import {BackdropModule} from '../vision/backdrop/backdrop.module';
import {TabsModule} from '../vision/tabs';
import {FloorPlanDeviceListComponent} from './components/floor-plan-device-list/floor-plan-device-list.component';

@NgModule({
  imports: [
    StoreModule.forFeature('floor-plan', reducers),
    EffectsModule.forFeature([
      FloorPlanViewEffects
    ]),
    CommonModule,
    FloorPlanRoutingModule,
    ButtonModule,
    MatDialogModule,
    FloorPlanEditorModule,
    IconModule,
    FloorPlanSharedModule,
    SharedModule,
    BackdropModule,
    TabsModule
  ],
  exports: [
    FloorPlanComponent,
    FloorPlanMapComponent,
    FloorPlanEmptyComponent,
    FloorPlanHeaderComponent,
    AirComponentPickerComponent,
    FloorPlanDeviceListComponent
  ],
  declarations: [
    FloorPlanComponent,
    FloorPlanMapComponent,
    FloorPlanEmptyComponent,
    FloorPlanHeaderComponent,
    DeviceMarkerComponent,
    AirComponentPickerComponent,
    FloorPlanSidebarComponent,
    FloorPlanDeviceListComponent
  ],
  entryComponents: [
    DeviceMarkerComponent
  ]
})
export class FloorPlanModule {
}
